/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TWEEN from "@tweenjs/tween.js";

import { const_var, params } from '../../redux/reducers/reducer'
import { setActiveBuildingWall } from '../../action';
// import { captureBlobImages, isAllCaptured } from '../../action/orderExtras.action';

const CameraController = () => {
    const dispatch = useDispatch();


    let fLength = params.p_d;
    let fWidth = params.p_w;     
    let fHeight = params.p_h + (params.p_w / 2 * (params.p_r_p / 12))
    params.add_front_lean && (fLength += params.leanF_p_w);
    params.add_back_lean && (fLength += params.leanB_p_w);
    params.add_left_lean && (fWidth += params.lean_p_w);
    params.add_right_lean && (fWidth += params.leanR_p_w);

    const buildingTypeId = useSelector(state => state.reducer.OlddefaultBuilding)
    
    // useEffect(() => {
        // if (const_var.checkValidate === false) {

            // const d = 25
            // const positions = [
            //     { x: params.p_w / 2 + (params.add_right_lean? params.leanR_p_w : 0) + d /4 * 3, y: params.p_h / 2, z: params.p_d / 2 + (params.add_front_lean? params.leanF_p_w : 0) + (params.add_left_lean? params.lean_p_w : 0) + d },
            //     { x: (params.p_d / 4 * 3 + Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d), y: params.p_h / 2, z: 0 },
            //     { x: 0, y: params.p_h / 2, z: -(params.p_d / 2 + Math.max(params.add_back_lean ? params.leanB_p_w : 0, params.add_left_lean ? params.lean_p_w : 0, params.add_right_lean ? params.leanR_p_w : 0) + d)},
            //     { x: -(params.p_d / 4 * 3 + Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d), y: params.p_h / 2, z: 0 },
            //     { x: 0, y: (params.p_d / 4 * 3 + (( params.p_r_p / 12)*(params.p_w / 2))) * 2 +  Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d, z: 0 },
            // ];
            // let i = 0;
            // const recursive = () => {
            //     const camera = const_var.camera;
            //     const controls = const_var.controls;
            //     const targetPosition = positions[i]
                
            //     if(i>positions.length - 1) {
            //         dispatch(isAllCaptured(true))
            //         i = 0;
            //         return;
            //     }
                
            //     new TWEEN.Tween(camera.position)
            //     .to(targetPosition, 300)
            //     .onUpdate(() => {
            //         controls.target.set(0, params.p_h / 2, 0);
            //         controls.update(); // Make sure controls are updated with the new camera position
            //     })
            //     .onComplete(() => {
            //         console.log('Animation completed for iteration', i);
            //         dispatch(captureBlobImages());
            //         i++
            //         setTimeout(() => {
            //             console.log("imgArray", const_var.i_g_A_y);
            //             recursive()
            //         }, 100);
            //     })
            //     .start();
            // } 
            // recursive()
            // capturebuildingImages()
        // }
    // }, [const_var.checkValidate])

    useEffect(() => {
        if (const_var.controls !== undefined && const_var.camera !== undefined && const_var.renderer?.domElement !== undefined) {

            const ar = const_var.renderer.domElement.clientWidth / const_var.renderer.domElement.clientHeight;
            if (fHeight > fWidth / 2) fWidth = fHeight * 2;
            let z = (fLength / 2) + (((fWidth / 2) / Math.tan((const_var.camera.fov / (180 * 2) * Math.PI))) / ar) * 1.7 ;
            if (const_var.renderer.domElement.clientWidth < 950) {
                z = (fLength / 2) + (((fWidth / 2) / Math.tan((const_var.camera.fov / (180 * 2) * Math.PI))) / ar) * 1.7 ;
            } 

            new TWEEN.Tween(const_var.camera?.position).to({ x: 0, y: params.p_h / 2, z }, 1000).start();
            const_var.controls.target?.set(0, params.p_h / 2, 0);
        }
        
        //dispatch(setActiveBuildingWall('c_b_f_w'));
    
    }, [/* const_var.controls, const_var.camera, */ params.p_w, params.p_d, params.p_h, params.p_r_p, params.p_r_s])

    // useEffect(() => {
        
    //     if (const_var.controls !== undefined) {
    //         const_var.controls.target?.set(0, params.p_h / 2, 0);      
    //         const currentAzimuthalAngle = const_var.controls.getAzimuthalAngle();
    //         const camAngle = (Math.atan((params.p_d / 2) / (params.p_w / 2)))
    //         if (currentAzimuthalAngle >= -(Math.PI / 2 - camAngle) && currentAzimuthalAngle < (Math.PI / 2 - camAngle)) {
    //             dispatch(setActiveBuildingWall('c_b_f_w'));
    //         } else if (currentAzimuthalAngle >= (Math.PI / 2 - camAngle) && currentAzimuthalAngle < ((Math.PI / 2 - camAngle) + camAngle * 2)) {
    //             dispatch(setActiveBuildingWall('c_b_r_w'));
    //         } else if (currentAzimuthalAngle >= -((Math.PI / 2 - camAngle) + camAngle * 2) && currentAzimuthalAngle < -(Math.PI / 2 - camAngle)) {
    //             dispatch(setActiveBuildingWall('c_b_l_w'));
    //         } else {
    //             dispatch(setActiveBuildingWall('c_b_b_w'));
    //         }
    //     }
    
    // }, [/* const_var.controls, */ const_var.activeTab])

    useEffect(() => {
        if (params.p_b_t && const_var.controls !== undefined && const_var.camera !== undefined) {

            const ar = window.innerWidth / window.innerHeight;
            const offset = (((fWidth / 2+ fLength / 3) / 0.221) / (ar * ar * 1.5));
            new TWEEN.Tween(const_var.camera?.position).to({ x: offset + fWidth + 10, y: fHeight / 2, z: offset + fWidth  + fLength  + params.p_r_p / 2}, 1000).start();
            const_var.controls.target?.set(0, params.p_h / 2, 0);
        }
        
        if (const_var.isFromCompare) const_var.isFromCompare = false;
    }, [/* const_var.controls, const_var.camera, */ params.toggleBuildingStyleChange, params.p_b_t, buildingTypeId, params.add_left_lean, params.add_right_lean])
    
    animate()

    function animate() {
        requestAnimationFrame(animate)
        TWEEN.update()
        if(const_var.camera != undefined && const_var.camera != ""){
            let x = const_var.camera.position.x
            let y = const_var.camera.position.y
            let z = const_var.camera.position.z
            const radius = Math.sqrt(x * x + y * y + z * z);
            // const condition = (params.add_front_lean || params.add_back_lean) ? params.p_d/2 + params.p_h + 26 : params.p_d/2 + params.p_h + 2;

            let fLength = params.p_d;
            let fWidth = params.p_w;     
            let fHeight = params.p_h + (params.p_w / 2 * (params.p_r_p / 12))
            params.add_front_lean && (fLength += params.leanF_p_w);
            params.add_back_lean && (fLength += params.leanB_p_w);
            params.add_left_lean && (fWidth += params.lean_p_w);
            params.add_right_lean && (fWidth += params.leanR_p_w);

            const condition = Math.sqrt(fWidth * fWidth + fHeight * fHeight + fLength * fLength) + 20;

            if(radius > condition){
                const_var.camera.near = 20
                const_var.camera.updateProjectionMatrix();
            }else{
                const_var.camera.near = 1
                const_var.camera.updateProjectionMatrix();
            }
        }
    }    
}

export default CameraController